var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "group",
    class: [{
      group_active: _vm.active
    }]
  }, [_c('div', {
    staticClass: "group__title",
    on: {
      "click": _vm.onClick
    }
  }, [_vm._v("\n    " + _vm._s(_vm.name) + "\n    "), _vm.activeCount > 0 ? _c('span', {
    staticClass: "group__active-count"
  }, [_vm._v(_vm._s(_vm.activeCount))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "group__list"
  }, [_vm._t("default")], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }